import { useMemo } from 'react';

import { ColumnChart } from 'components/Chart';

import type { FC } from 'react';
import type { YAxisPlotLinesOptions } from 'highcharts/highcharts';
import type { BalanceEntry } from 'components/Calculator/types';

interface AnnualAmountsChartProps {
  balances: BalanceEntry[];
  title: string;
  columnLabel: string;
  columnsTitle?: string;
  plotLines?: YAxisPlotLinesOptions[];
  min?: number;
  max?: number;
}

export const AnnualAmountsChart: FC<AnnualAmountsChartProps> = ({
  balances,
  title,
  columnLabel,
  columnsTitle = 'Years',
  plotLines,
  min,
  max,
}) => {
  const data = useMemo(() => balances.map(yearlyBalance => yearlyBalance.amount), [balances]);
  const entries = useMemo(
    () => balances.map(yearlyBalance => `${yearlyBalance.entry}`),
    [balances]
  );

  return (
    <ColumnChart
      title={title}
      columnsTitle={columnsTitle}
      categories={entries}
      data={data}
      columnLabel={columnLabel}
      plotLines={plotLines}
      min={min}
      max={max}
    />
  );
};
